<template>
  <div>
    <div class="row">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h3>Sites</h3>
      </div>

      <div class="col-md-4 offset-md-4">
        <p-button
          class="btn btn-success pull-right"
          @click="handleAddSiteButton"
          v-if="hasAddNewSitePermission"
        >
          <i class="fas fa-map-marker-alt"></i> Add a new Site
        </p-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 card">
        <!-- <div class="card-header">
          <div class="category">Extended tables</div>
        </div>-->
        <div class="card-body row">
          <div class="col-sm-6">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input
                class="input-sm"
                placeholder="Search"
                v-model="searchQuery"
                addon-right-icon="nc-icon nc-zoom-split"
              ></fg-input>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <p>Address: {{ props.row.address }}</p>
                  <p>City: {{ props.row.city }}</p>
                  <p>State: {{ props.row.state }}</p>
                  <p>Latitude: {{ props.row.latitude }}</p>
                  <p>Longitude: {{ props.row.longitude }}</p>
                </template>
              </el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                align="center"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                ><template slot-scope="scope">
                  {{ scope.row[column.prop] || "-" }}
                </template></el-table-column
              >
              <el-table-column prop="status" label="Status" width="120">
                <template slot-scope="scope">
                  <el-tag
                    :type="
                      scope.row.status_description === 'ACTIVE'
                        ? 'success'
                        : 'danger'
                    "
                    disable-transitions
                    >{{ scope.row.status_description }}</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                :min-width="120"
                fixed="right"
                class-name="td-actions"
                label="Actions"
                width="150"
              >
                <template slot-scope="props">
                  <el-tooltip content="Go to Site" placement="top">
                    <p-button
                      type="info"
                      size="sm"
                      icon
                      @click="handleLink(props.$index, props.row)"
                    >
                      <i class="fas fa-link"></i>
                    </p-button>
                  </el-tooltip>
                  <el-tooltip content="Edit Site" placement="top">
                    <p-button
                      type="warning"
                      size="sm"
                      icon
                      @click="handleEdit(props.$index, props.row)"
                      v-if="hasSiteEditPermission(props.row)"
                    >
                      <i class="fas fa-edit"></i>
                    </p-button>
                  </el-tooltip>
                  <!-- <el-tooltip
                    content="Delete Site"
                    placement="top">
                    <p-button type="danger" size="sm" icon @click="handleEdit(props.$index, props.row)">
                      <i class="fas fa-trash-alt"></i>
                    </p-button>
                  </el-tooltip>-->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>

    <modal
      :show.sync="addNewSite"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h5 slot="header" class="text-primary modal-title" v-if="!isEditing">
        Add a new Site
      </h5>
      <h5 slot="header" class="text-primary modal-title" v-else>
        Edit Site
        <span class="span-site-name">{{ siteModel.name }}</span>
      </h5>
      <template>
        <form>
          <div class="form-group">
            <fg-input
              label="Name"
              name="name"
              v-model="siteModel.name"
              :error="getError('name')"
              v-validate="siteModelValidations.name"
            ></fg-input>
          </div>
          <div class="form-group">
            <fg-input
              label="Address"
              name="address"
              v-model="siteModel.address"
              :error="getError('address')"
              v-validate="siteModelValidations.address"
            ></fg-input>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <fg-input
                label="City"
                name="city"
                v-model="siteModel.city"
                :error="getError('city')"
                v-validate="siteModelValidations.city"
              ></fg-input>
            </div>
            <div class="form-group col-md-6">
              <fg-input :error="getError('state')">
                <label for="inputState">State</label>
                <select
                  id="inputState"
                  name="state"
                  class="form-control"
                  v-model="siteModel.state"
                  v-validate="siteModelValidations.state"
                >
                  <option :value="null" disabled>Select State</option>
                  <option
                    v-for="state in $options.us_states"
                    :value="state.abbreviation"
                    v-bind:key="state.name"
                  >
                    {{ state.abbreviation }}
                  </option>
                </select>
              </fg-input>
            </div>
          </div>
          <div class="form-group">
            <fg-input
              label="Latitude"
              name="latitude"
              type="number"
              :error="getError('latitude')"
              v-model="siteModel.latitude"
              v-validate="siteModelValidations.latitude"
            ></fg-input>
          </div>
          <div class="form-group">
            <fg-input
              label="Longitude"
              name="longitude"
              type="number"
              :error="getError('longitude')"
              v-model="siteModel.longitude"
              v-validate="siteModelValidations.longitude"
            ></fg-input>
          </div>
          <div class="form-group">
            <fg-input
              label="Type"
              name="type"
              :error="getError('type')"
              v-model="siteModel.site_type"
              v-validate="siteModelValidations.type"
            ></fg-input>
          </div>
          <div class="form-group">
            <fg-input :error="getError('status')">
              <label for="inputStatus">Status</label>
              <select
                id="inputStatus"
                name="status"
                class="form-control"
                v-model="siteModel.status_id"
                v-validate="siteModelValidations.status"
              >
                <option :value="null" disabled>Select Status</option>
                <option
                  v-for="status in siteStatus"
                  :value="status.id"
                  v-bind:key="status.description"
                >
                  {{ status.description }}
                </option>
              </select>
            </fg-input>
          </div>
          <div class="form-group">
            <fg-input
              label="Site Id"
              name="site_id"
              type="number"
              :error="getError('site_id')"
              v-model="siteModel.site_id"
              v-validate="siteModelValidations.site_id"
            ></fg-input>
          </div>
        </form>
      </template>
      <template slot="footer">
        <p-button type="danger" @click.native="addNewSite = false"
          >Close</p-button
        >
        <p-button type="success" @click.native="addSite" v-if="!isEditing"
          >Add Site</p-button
        >
        <p-button type="success" @click.native="editSite" v-else>Save</p-button>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Input,
  InputNumber,
  Form,
  FormItem,
  Button,
  Radio,
  Tooltip,
  Tag,
} from "element-ui";
import users from "src/components/Dashboard/Views/Tables/users";
import HTTP from "src/util/http-common.js";
import US_STATES from "src/util/us_states.js";
import Modal from "src/components/UIComponents/Modal.vue";
import { parse } from "path";
import swal from "sweetalert2";

export default {
  us_states: US_STATES,
  components: {
    Modal,
    [InputNumber.name]: InputNumber,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Tooltip.name]: Tooltip,
    [Tag.name]: Tag,
  },
  data() {
    return {
      user_permissions: {
        canshowAdduser: false,
        canshowRolePut: false,
        canshowSitePost: false,
        canShowSitesGet: false,
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [2, 5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["name", "email", "age"],
      tableColumns: [
        {
          prop: "site_id",
          label: "Site Id",
          minWidth: 120,
        },
        {
          prop: "name",
          label: "Name",
          minWidth: 120,
        },
        {
          prop: "create_time",
          label: "Create Time",
          minWidth: 120,
        },
      ],
      tableData: [],
      addNewSite: false,
      siteStatus: [],
      isEditing: false,
      siteModel: {
        name: null,
        address: null,
        city: null,
        state: null,
        latitude: null,
        longitude: null,
        site_type: null,
        status_id: null,
        site_id: null,
      },
      originalEditModel: {},
      siteModelValidations: {
        name: {
          required: true,
        },
        address: {
          required: true,
        },
        city: {
          required: true,
        },
        state: {
          required: true,
        },
        latitude: {
          required: true,
        },
        longitude: {
          required: true,
        },
        type: {
          required: true,
        },
        status: {
          required: true,
        },
        site_id: {
          required: true,
        },
      },
      generalPermissions: this.$store.getters["auth/generalPermissions"],
      sitePermissions: this.$store.getters["auth/sitePermissions"],
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    hasAddNewSitePermission() {
      if (this.user_permissions.canshowSitePost) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    "pagination.perPage": function (newVal, oldVal) {
      this.pagination.currentPage = 1;
      this.setSites();
    },
    searchQuery: function (newVal, oldVal) {
      this.setSites();
    },
    addNewSite: function (newVal, oldVal) {
      if (newVal == false) {
        this.siteModel.state = null;
        this.siteModel.name = "";
        this.siteModel.address = "";
        this.siteModel.city = "";
        this.siteModel.latitude = null;
        this.siteModel.longitude = null;
        this.siteModel.site_type = "";
        this.siteModel.status_id = null;
        this.siteModel.site_id = null;
        this.isEditing = false;
      } else {
        this.$validator.errors.clear();
        this.setStatus();
      }
    },
    "pagination.currentPage": function (newVal, oldVal) {
      this.setSites();
    },
  },
  created() {
    this.setSites();
  },
  mounted() {
    this.checkPermissions();

    var p = localStorage.getItem("permissions");
    var pr = JSON.parse(p);
    var permissions = pr.permissions;

    var canShowsites = permissions.includes("site.get");

    if (canShowsites === false) {
      this.$router.push({ path: "/" });
    }
  },
  methods: {
    checkPermissions() {
      //this.showAdduser
      var p = localStorage.getItem("permissions");
      var pr = JSON.parse(p);
      var permissions = pr.permissions;
      this.user_permissions.canshowAdduser = permissions.includes("user.post");
      this.user_permissions.canshowRolePut = permissions.includes("role.put");
      this.user_permissions.canshowSitePost = permissions.includes("site.post");
      this.user_permissions.canShowSitesGet = permissions.includes("site.get");
      if (!this.user_permissions.canShowSitesGet) {
        this.$router.push({ path: "/" });
      }
    },
    handleLink(index, row) {
      this.$router.push({ path: `/sites/${row.id}` });
      // alert(`Your want to like ${row.id}`)
    },
    handleEdit(index, row) {
      this.siteModel = Vue.util.extend({}, row);
      this.originalEditModel = Vue.util.extend({}, row);
      this.addNewSite = true;
      this.isEditing = true;
    },
    rowClicked() {
      console.log("hey I was clicked!");
    },
    inputChanged(pageNum) {
      this.setSites();
    },
    async fetchSites() {
      const response = await HTTP.get("api/v1/site/list", {
        params: {
          page: this.pagination.currentPage,
          page_size: this.pagination.perPage,
          search_query: this.searchQuery,
        },
      });
      const data = await response.data;
      return data;
    },
    setSites() {
      let loader = this.$loading.show();
      this.fetchSites()
        .then((data) => {
          for (let row of data.results) {
            row.create_time = this.$moment
              .unix(row.create_time)
              .format("MMMM Do YYYY, h:mm:ss a");
          }
          this.tableData = data.results;
          this.pagination.total = data.total;
          loader.hide();
        })
        .catch((err) => {
          console.log(err);
          loader.hide();
          // alert(err);
        });
    },
    async fetchSiteStatus() {
      const response = await HTTP.get("api/v1/site/status", {});
      const data = await response.data;
      return data;
    },
    setStatus() {
      this.fetchSiteStatus().then((data) => {
        this.siteStatus = data;
      });
    },
    handleAddSiteButton() {
      this.addNewSite = true;
    },
    onSubmit() {
      console.log("submit!");
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    createSiteAPI() {
      this.siteModel.latitude = parseFloat(this.siteModel.latitude);
      this.siteModel.longitude = parseFloat(this.siteModel.longitude);
      this.siteModel.site_id = parseInt(this.siteModel.site_id);
      HTTP.post("api/v1/site/", this.siteModel)
        .then((response) => {
          const siteId = response.data.site_id;
          this.addNewSite = false;
          this.$store.dispatch("auth/retrieveUserPermissions");
          this.$router.push({ name: "Site Page", params: { siteId: siteId } });
        })
        .catch((err) => {
          const error = err.response.data.error;
          const reason = err.response.data.reason;
          const status_code = err.response.status;
          if (status_code == 500) {
            swal({
              title: "Server Error",
              text: "Internal Server Error. Please try again later..",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
            return;
          }
          swal({
            title: error,
            text: reason,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-danger btn-fill",
            type: "error",
          });
        });
    },
    async addSite() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.createSiteAPI();
      }
    },
    editSite() {
      let newModel = {};
      for (var key in this.siteModel) {
        if (this.siteModel[key] != this.originalEditModel[key]) {
          newModel[key] = this.siteModel[key];
        }
      }
      if (Object.keys(newModel).length != 0) {
        HTTP.put("api/v1/site/" + this.originalEditModel["id"], {
          ...newModel,
        })
          .then((response) => {
            swal({
              title: "Successfully Edited Site",
              text: "",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success btn-fill",
              type: "success",
            });
            this.addNewSite = false;
            this.isEditing = false;
            this.setSites();
          })
          .catch((err) => {
            const error = err.response.data.error;
            swal({
              title: "Encountered an error while trying to update site.",
              text: error,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          });
      }
    },
    hasSiteEditPermission(row) {
      var strId = row.id.toString();
      try {
        if (this.sitePermissions.permissions.includes("site.put")) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        // this.$notify({
        //     group: 'general',
        //     title: 'Permission Error',
        //     text: 'Please re log-in to reset your site permissions',
        //     type: 'error'
        // });
        return false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
.span-site-name {
  text-transform: uppercase;
  color: #848484;
  white-space: nowrap;
}
</style>
